export const API_BASE_URL = 'https://library-backend.songoda.workers.dev';

export const API_ENDPOINTS = {
    BOOKS: '/api/books'
};